import {Contract} from 'ethers';
import { default as config, provider } from '../config';
import labsMinterABI from '../libs/abi/LabsERC721DynamicMinter.json';

const address: string = config.labsMinterAddress;

export const contract = new Contract(address, labsMinterABI.abi, provider);